import InviteUserPage from "@/features/invite/components/InviteUserPage";
import { useInviteCopy } from "@/features/i18n/inviteCopy";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";
import { validateSignupSearch } from "@/routes/_auth/_public/signup.index";

const InvitePage = () => {
    const search = Route.useSearch();
    const copy = useProfileCopy();
    const inviteCopy = useInviteCopy();

    useNav([
        { label: copy.title, route: { to: "/profile" } },
        { label: copy.myTeam, route: { to: "/team" } },
        { route: { to: "/invite" }, label: inviteCopy.invitePageTitle },
    ]);

    return <InviteUserPage defaultRole={search.role} defaultOrganisationId={search.organisation?.organisation_id} />;
};

export const Route = createFileRoute("/_app/invite/")({
    component: InvitePage,
    validateSearch: validateSignupSearch,
});
